import { Trans } from '@lingui/macro'
import HYDRA_STAKING_ABI from 'abis/governance/HydraStaking.json'
import { useHydraStakingContract } from 'hooks/useGovernanceContracts'

import ContractWidget from '../components/ContractWidget'
import { SectionTitle } from '../styleds'

export default function HydraStakingTab() {
  const contract = useHydraStakingContract()

  return (
    <>
      <SectionTitle>
        <Trans>HydraStaking Contract (0x...0104)</Trans>
      </SectionTitle>

      <ContractWidget
        title="HydraStaking"
        description="Staking contract for validators. Handles stake/unstake, vesting positions, rewards distribution, and penalty mechanisms."
        contract={contract}
        abi={HYDRA_STAKING_ABI as any}
        defaultFunction="totalStake"
      />
    </>
  )
}
